import { Injectable } from '@angular/core';
import { DisbursementCutOffStatus } from '@merchant-portal/app/models/disbursement/disbursement.interface';
import {
  BulkTransactionFilter,
  IBulkTransactionResponse,
} from 'projects/merchant-portal/src/app/models/disbursement/bulk-transaction/bulk-transaction.interface';
import { Observable } from 'rxjs';

@Injectable()
export abstract class BulkTransactionFactoryService {
  abstract isLoading$: Observable<boolean>;
  abstract currentBulkTransaction$: Observable<IBulkTransactionResponse['data']>;
  abstract currentBulkTransactionPagination$: Observable<IBulkTransactionResponse['meta']>;
  abstract currentBulkTransactionFilter$: Observable<Partial<BulkTransactionFilter>>;
  abstract requestBulkTransaction(param: Partial<BulkTransactionFilter>): void;
  abstract checkCutOffTime(): Observable<DisbursementCutOffStatus>;
}
